(function ($) {
  Drupal.behaviors.rangeSlider = {
    attach: function (context, settings) {
      var $templates = $('.js-range-slider', context);

      $templates.each(function (i, obj) {
        var $template = $(obj);

        if ($template.data('mantle-range-slider')) {
          return;
        }
        var manager = new MantleRangeSlider($template);

        $template.data('mantle-range-slider', manager);

        var $slider = manager.$slider;

        $slider.on('form-set-values', function (e, values) {
          if (!manager.tick_map) {
            return;
          }
          if (!values) {
            return;
          }
          if (typeof values == 'string') {
            values = [values];
          }
          var value = values[0];
          var tick_num = null;

          $.each(manager.tick_map, function (i, obj) {
            if (value == obj) {
              tick_num = i;

              return false;
            }
          });

          if (tick_num != null) {
            $slider.trigger('lock-to-tick', [tick_num]);
          }
        });

        $slider.on('slide-to', function (event, tick_num, duration, step_check) {
          var new_val = tick_num;
          var current_val = $slider.val();

          // set the tick value immiedately so get_slider_val is correct. The
          // animation isn't considered the actual input value.
          $slider.trigger('set-tick-value', tick_num);
          step_check = true;
          $({ val: current_val }).animate(
            { val: new_val },
            {
              duration: duration,
              step: function (now) {
                $slider.val(now);
                if (step_check) {
                  $slider.trigger('change');
                } else {
                }
              },
              complete: function () {
                manager.touch_sliding = false;
                $slider.trigger('update-self');
                $slider.trigger('set-tick', tick_num);
              }
            }
          );
        });

        if ($slider.data('starting')) {
          setTimeout(function ($slider) {
            var starting_tick = parseInt($slider.data('starting'));

            $slider.trigger('lock-to-tick', [starting_tick, 0]);
          }, 100, $slider);
        }
      });
    }
  };
})(jQuery);
